/*
===============================================================================================================
                                 Copyright 2022-2023, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LocaleContext } from '@/contexts/locale-context';
import { ThemeContext } from '@/contexts/theme-context';

export default function ButtonSave({
  onClick,
  onKeyDown,
  inputSelectorId,
}) {
  const { translate } = useContext(LocaleContext);
  const { primaryColor, hoverPrimaryColor, buttonTextColor } = useContext(ThemeContext);
  return (
    <>
      <button
        id={inputSelectorId}
        type="button"
        onClick={onClick}
        onKeyDown={onKeyDown}
      >
        {translate('constants.save')}
      </button>
      <style jsx>
        {`
          button {
            cursor: pointer;
            background-color: ${primaryColor};
            border-radius: 21px;
            border: none;
            color: ${buttonTextColor || 'var(--color-white)'};
            font-size: var(--font-size-body);
            font-weight: var(--font-weight-body);
            height: auto;
            padding: 6px 22px;
            width: auto;
          }

          button:hover {
            background-color: ${hoverPrimaryColor};
            transition: background-color 0.1s linear;
          }
        `}
      </style>
    </>
  );
}

ButtonSave.defaultProps = {
  onKeyDown: null,
  inputSelectorId: null,
};

ButtonSave.propTypes = {
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  inputSelectorId: PropTypes.string,
};
